import Enumerable from "linq";
import { AccessFunctionalityTypeEnum } from "../../common/enums/AccessFunctionalityTypeEnum";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { shapePermissionsData } from "../../common/utilities/PermissionsUtils";
import { IAccessFunctionalityHashes } from "../../common/models/IAccessFunctionalityHashes";
import { IPermissionModel } from "../../common/models/IPermissionModel";
import { IObjectSecurityModel } from "../../common/models/IObjectSecurityModel";
import { IAccessFunctionalityData } from "../../common/models/IAccessFunctionalityData";

export function usePermissions({
    objectSecurityData,
    accessFunctionalityData,
    accessFunctionalityMasks,
    accessFunctionalityHashes }: {
        objectSecurityData: IObjectSecurityModel[] | undefined;
        accessFunctionalityData: IAccessFunctionalityData | undefined;
        accessFunctionalityMasks: Enumerable.IDictionary<eLynxObjectTypeEnum, Enumerable.IDictionary<AccessFunctionalityTypeEnum, number>> | undefined;
        accessFunctionalityHashes: Enumerable.IDictionary<eLynxObjectTypeEnum, IAccessFunctionalityHashes> | undefined;
    }

): IPermissionModel[] | undefined {

    const permissions = objectSecurityData &&
        accessFunctionalityData &&
        accessFunctionalityMasks &&
        //User Story 53044: Research - 2025 Q2 - Review GAS report
        accessFunctionalityHashes
        ? shapePermissionsData(
            objectSecurityData,
            accessFunctionalityData as IAccessFunctionalityData,
            accessFunctionalityMasks as Enumerable.IDictionary<eLynxObjectTypeEnum, Enumerable.IDictionary<AccessFunctionalityTypeEnum, number>>,
            accessFunctionalityHashes as Enumerable.IDictionary<eLynxObjectTypeEnum, IAccessFunctionalityHashes>
        )
        : undefined;

    return permissions;
}